import { createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

import { createAppSlice } from '../create-app-slice';
import { fetchOutdoorPhotos, OutdoorPhoto } from '@external';
import { stateInitializer } from './state-initializer';

export type LoadOutdoorPhotosPayload = {
	dealId: string;
	photos: Array<OutdoorPhoto>;
};

export const loadOutdoorPhotos = createAsyncThunk(
	'outdoorPhotos/load',
	async (dealId: string, { rejectWithValue, extra }) => {
		const { getToken } = extra as { getToken: () => Promise<string> };
		const [photos, error] = await fetchOutdoorPhotos({ dealId, getToken });
		if (error) return rejectWithValue(error);
		return { dealId, photos: photos ?? [] } as LoadOutdoorPhotosPayload;
	}
);

export const slice = createAppSlice({
	name: 'outdoorPhotos',
	initialState: stateInitializer(),
	reducers: (create) => ({}),
	extraReducers: (builder) => {
		builder
			.addCase(loadOutdoorPhotos.pending, (state) => {
				state.status = 'loading';
				state.error = null;
			})
			.addCase(loadOutdoorPhotos.fulfilled, (state, action: PayloadAction<LoadOutdoorPhotosPayload>) => {
				const { dealId, photos } = action.payload;
				state.photos = photos;
				state.status = 'loaded';
				state.dealId = dealId;
				state.error = null;
			})
			.addCase(loadOutdoorPhotos.rejected, (state, action) => {
				state.status = 'error';
				state.error = action.payload as string ?? 'Error loading outdoor photos';
			});
	},
	selectors: {
		selectOutdoorPhotos: (state) => state.photos,
		selectOutdoorPhotosStatus: (state) => state.status,
		selectOutdoorPhotosDealId: (state) => state.dealId
	}
});
